<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section>
            <div class="card">
                <div class="card-header">
                    <h3>{{"SEARCH" | translate}} {{"AND" | translate}} {{"FILTER" | translate }}</h3>
                    <label class="d-flex  align-items-center" *ngIf="tableLimit">{{"SHOW" | translate}}
                        <select class="form-control ml-075 pr-3" (change)="tableLimit=$event.target.value">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                </div>
                <div class="card-body row">
                    <div class="col-md-4 col-sm-12">
                        <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_keyword"/>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <select name="category" id="category" [(ngModel)]="filter_category" class="form-control">
                            <option value="">{{"FILTER_CATEGORY" | translate}}</option>
                            <option *ngFor="let cat of documents_categories" [value]="cat">{{cat}}</option>
                        </select>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <select name="category" id="status" [(ngModel)]="filter_status" class="form-control">
                            <option value="">{{"FILTER_STATE" | translate}}</option>
                            <option *ngFor="let status of documents_statuses" [value]="status.value">{{status.label}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="currentUser">
                <div class="card-body p-0">
                    <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="50" [scrollbarH]="true" [rowHeight]="70" [limit]="tableLimit" [footerHeight]="50" [rows]="getItems()">
                        <ngx-datatable-column [name]="'DOCUMENT'|translate" prop="name" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="d-flex align-items-center">
                                    <img src="/assets/images/icons/{{row.type}}.png" width="20" class="mr-05" alt="" />
                                    <span class="font-medium-1">{{ row.name }}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [name]="'CATEGORY'|translate" prop="category" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="font-medium-1">{{ row.category }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [name]="'STATE'|translate" prop="status" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-pill badge-light-success mr-1" *ngIf="row.status == 'archived'">{{ row.status_name }}</span>
                                <span class="badge badge-pill badge-light-warning mr-1" *ngIf="row.status == 'pending'">{{ row.status_name }}</span>
                                <span class="badge badge-pill badge-light-info mr-1" *ngIf="row.status == 'request-sign'">{{ row.status_name }}</span>
                                <span class="badge badge-pill badge-light-danger mr-1" *ngIf="row.status == 'rejected'">{{ row.status_name }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>

        </section>
    </div>
</div>